import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '⚡️',
    title: 'pages.onboarding.timeQuestion.answer1',
    subtitle: 'pages.onboarding.timeQuestion.answer1Subtitle',
  },
  {
    emoji: '🎯️',
    title: 'pages.onboarding.timeQuestion.answer2',
    subtitle: 'pages.onboarding.timeQuestion.answer2Subtitle',
  },
  {
    emoji: '📈',
    title: 'pages.onboarding.timeQuestion.answer3',
    subtitle: 'pages.onboarding.timeQuestion.answer3Subtitle',
  },
  {
    emoji: '🚀',
    title: 'pages.onboarding.timeQuestion.answer4',
    subtitle: 'pages.onboarding.timeQuestion.answer4Subtitle',
  },
  {
    emoji: '💪',
    title: 'pages.onboarding.timeQuestion.answer5',
    subtitle: 'pages.onboarding.timeQuestion.answer5Subtitle',
  },
]

export default function TimeQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      subtitle="pages.onboarding.timeQuestion.subtitle"
      title="pages.onboarding.timeQuestion.title"
    />
  )
}
